import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { Routes } from '@/router';
import { OrderType } from '@/models';
import { AnalyticsEventCategory, AnalyticsEventAction, AnalyticsEventLabel } from '@/services/google/google-analytics.services';
import { ui } from '@/constants';

@Component({ name: 'CmgCancelGroupOrderModal' })
export default class CmgCancelGroupOrderModal extends Vue {
  isCancelling = false;

  get visible(): boolean {
    return this.$appStore.state.ui.modals.cancelGroupOrder.visible;
  }

  get isMobile(): boolean {
    return this.$appStore.state.ui.clientWidth <= ui.breakpoints.phoneLgMax;
  }

  close() {
    this.$services.ui.setModalVisibility('cancelGroupOrder', false);
    this.$services.ui.focusBack();
  }

  async onClickCancelGroupOrder() {
    if (this.$appStore.state.order.pendingGroupOrder == null) {
      this.$services.logger.unreachable('Trying to cancel a NULL order');
      return;
    }

    this.isCancelling = true;
    try {
      await this.$services.order.cancelOrder(this.$appStore.state.order.pendingGroupOrder.order.orderId, OrderType.Group);

      this.$services.googleAnalytics.sendCustomEvent({ 
        category: AnalyticsEventCategory.Behavior,
        action: AnalyticsEventAction.Click,
        label: AnalyticsEventLabel.CancelGroupOrder,
      });
    } catch (e: any) {
      // TODO-268ry6: If cancel order isn't successful, then participants can still add meals.
      // Resetting cached order will at least allow host to continue on with their ordering.
      this.$services.order.resetPendingGroupOrder();
      this.$services.logger.error('Error cancelling group order', e);
    } finally {
      this.isCancelling = false;
      this.$router.push({ name: Routes.Order });
      this.$services.order.stopPollingGroupOrder();
      this.close();
    }
    const children = document.querySelectorAll('.bag-container .child-of-order-bag');
    const focusElement = children[0] as HTMLElement;
    if (focusElement) {
      focusElement.focus();
    }
  }
}
